import type { FaireProductEntity } from "../../entity_types/product";

export const p_k6vfyp4geb: FaireProductEntity = {
  token: "p_k6vfyp4geb",
  type: "product",
  name: "Wrist Relief Wellness Oil",
  brandToken: "b_cev7opt9ab",
  brandName: "Nature's Inventory",
  imageUrl:
    "https://cdn.faire.com/fastly/5ef60aab2381337a50b0547da63502c0b032d4cd75f8a555e07135275617e3fb.jpeg",
  galleryImageUrls: [],
  priceDollars: 11.06,
  description:
    "\nWith so many people’s jobs depending on typing on a computer, carpal tunnel syndrome is on the rise. A repetitive motion to the wrist can cause what seems like endless pain.  The essential oils in this formula were carefully chosen to reduce pain and inflammation to aid in immediate relief and long lasting healing.\n\n \n\nINGREDIENTS DIRECTIONS \nCocus Nucifera (fractionated coconut oil), Vitis vinifera (grapeseed oil), thymus mastichina (marjoram essential oil), eucalyptus globules (organic eucalyptus essential oil), matricaria chamomilla (organic chamomile essential oil), & eugenia aromatic (organic clove essential oil). Shake before use. Massage as much oil as needed into your wrist and the surrounding area. \n \n",
  tags: [],
  msrpDollars: 22.1,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:57:44.874Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
